// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CopyButtonController from "./copy_button_controller"
application.register("copy-button", CopyButtonController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ShareButtonController from "./share_button_controller"
application.register("share-button", ShareButtonController)


import SuburbAutocompleteController from "./suburb_autocomplete_controller"
application.register("suburb-autocomplete", SuburbAutocompleteController)

import ChurchSearchController from "./church_search_controller"
application.register("church-search", ChurchSearchController)

import PushNotificationsController from "./push_notifications_controller"
application.register("push-notifications", PushNotificationsController)
